import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Item } from '../Item'
import { swapOptions } from 'Core/constants'
import { getCurrentAd } from '../../../selectors'
import { getSwapItemName } from '../../../functions'

export const SwapList = ({ad: {swapp, adsSwapps}}) => {
  const items = []
  if (swapp && swapp !== 'No') {
    const arSwap = swapOptions.filter(item => item.value === swapp)
    if (arSwap.length) {
      items.push({
        id: 'swapp',
        property: 'Zamjena',
        value: arSwap[0].title
      })
    }
  }
  if (Array.isArray(adsSwapps)) {
    adsSwapps.forEach((swap, index) => {
      items.push({
        id: `swapps-${index}`,
        property: 'Zamjena za',
        value: getSwapItemName(swap)
      })
    })
  }
  return items.map(item => <Item key={item.id} {...item} />)
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state)
})

SwapList.propTypes = {
  ad: PropTypes.shape({
    swapp: PropTypes.oneOf(swapOptions.map(option => option.value)),
    adsSwapps: PropTypes.arrayOf(PropTypes.shape())
  })
}

export default connect(mapStateToProps)(SwapList)
